import { render } from "./StoreHero.vue?vue&type=template&id=01f522a7&scoped=true&bindings={\"shop\":\"data\",\"storeImage\":\"data\",\"trustItems\":\"data\",\"categories\":\"data\",\"onImageError\":\"options\"}"
import script from "./StoreHero.vue?vue&type=script&lang=js"
export * from "./StoreHero.vue?vue&type=script&lang=js"

import "./StoreHero.vue?vue&type=style&index=0&id=01f522a7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01f522a7"

export default script